// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageLoaderImageDisplay {
    display: inline-block;
    max-height: 15em;
    max-width: 20em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}

.ImageLoaderImageContainerContent {
    border-radius: 10px;
    background-color: var(--templatesColorBackgroundContainer);
    padding: 0.2em;
    animation: fadeInGlobal 1s;
}

.ImageLoaderImageContainerContentRemoved {
    opacity: 0.4;
    filter: grayscale(50%);
    border-radius: 10px;
    background-color: var(--templatesColorBackgroundContainer);
    padding: 0.2em;
}

.ImageLoaderImageContainerContentRemoved button {
    filter: invert();
}

.ImageLoaderImageContainerContentLoadingProgress {
    border-radius: 10px;
    background-color: var(--templatesColorBackgroundContainer);
    padding: 0.2em;
    opacity: 0.3;
    filter: grayscale(50%);
}

.ImageLoaderLoadingDisplay {
    position: absolute;
    left: 50%;
    margin-left: -12em;
    margin-top: 3em;
    z-index: 22;
}

.ImageLoaderImageContainerContentCountWarning {
    border-radius: 10px;
    background-color: rgb(128, 88, 40);
    padding: 0.2em;
    animation: fadeInGlobal 1s;
}

.ImageCardImageContainer {
    display: flex;
    padding: 0.5em;
    justify-content: center;
    row-gap: 1em;
    column-gap: 1em;
    border-radius: 10px;
}

.ImageLoaderImageAndTitle {
    /* border: 2px solid orange; */
    min-width: 20em;
    min-height: 10em;
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
}

.ImageLoaderTextAndButton {
    /* border: 2px solid red; */
    min-width: 19em;
    text-align: center;
    flex-grow: 2;
    display: flex;
    row-gap: 1em;
    column-gap: 1em;
    justify-content: center;
    padding: 1em;
}

.ImageLoaderLicenseText {
    border: 2px solid var(--templatesColorBackgroundInContainer);
    padding: 1em;
    border-radius: 5px;
    text-align: left;
    overflow: auto;
    min-width: 5em;
    flex-grow: 2;
    word-break: break-word;
    font-size: 14px;
}

.ImageLoaderLicenseText::-webkit-scrollbar {
    display: none;
}

.ImageLoaderInputValues {
    border: 2px solid var(--templatesColorBackgroundInContainer);
    padding: 1em;
    border-radius: 5px;
    flex-grow: 2;
    word-break: break-word;
    font-size: 14px;
}

.ImageLoaderImageBackButton {
    margin-left: auto;
}

.ImageLoaderTitle {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}

.ImageLoaderTitle p {
    color: white;
    font-weight: bold;
}

.ImageLoaderTitleAndBackButtonContainer {
    display: flex;
}

.ImageLoaderLineBreak {
    height: 3px;
    background-color: var(--templatesColorBackgroundInContainer);
    border: none;
}

@media screen and (max-width: 815px) {
    .ImageLoaderInputValues {
        font-size: 10px;
    }

    .ImageLoaderLicenseText {
        font-size: 10px;
    }
}

@media only screen and (max-width: 768px) {
    .ImageCardImageContainer {
        display: block;
    }

    .ImageLoaderImageContainerContent {
        width: 100%;
    }

    .ImageLoaderImageContainerContentRemoved {
        width: 100%;
    }

    .ImageLoaderImageContainerContentLoadingProgress {
        width: 100%;
    }

    .ImageLoaderImageContainerContentCountWarning {
        width: 100%;
    }

    .ImageLoaderLoadingDisplay {
        margin-left: -10em;
        margin-top: 5em;
    }

    .ImageLoaderImageDisplay {
        max-height: 9em;
    }
}

@media screen and (max-width: 360px) {
    .ImageLoaderTextAndButton {
        padding: 0em;
    }
}

@media screen and (max-width: 320px) {
    .ImageLoaderImageDisplay {
        max-height: 8em;
        max-width: 15em;
    }

    .ImageLoaderInputValues {
        padding: 0px;
        padding-right: 1.9em;
    }

    .ImageLoaderTextAndButton {
        row-gap: 0.1em;
        column-gap: 0.1em;
        min-width: 4em;
        transform: scale(0.9);
        flex-grow: 1;
    }

    .ImageLoaderImageAndTitle {
        min-width: 10em;
    }
}

@media screen and (max-width: 280px) {
    .ImageLoaderImageAndTitle {
        min-width: 1em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/CardContainer/CardContainer.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,0DAA0D;IAC1D,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,0DAA0D;IAC1D,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,0DAA0D;IAC1D,cAAc;IACd,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,4DAA4D;IAC5D,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4DAA4D;IAC5D,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,4DAA4D;IAC5D,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,cAAc;QACd,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ","sourcesContent":[".ImageLoaderImageDisplay {\n    display: inline-block;\n    max-height: 15em;\n    max-width: 20em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n\n.ImageLoaderImageContainerContent {\n    border-radius: 10px;\n    background-color: var(--templatesColorBackgroundContainer);\n    padding: 0.2em;\n    animation: fadeInGlobal 1s;\n}\n\n.ImageLoaderImageContainerContentRemoved {\n    opacity: 0.4;\n    filter: grayscale(50%);\n    border-radius: 10px;\n    background-color: var(--templatesColorBackgroundContainer);\n    padding: 0.2em;\n}\n\n.ImageLoaderImageContainerContentRemoved button {\n    filter: invert();\n}\n\n.ImageLoaderImageContainerContentLoadingProgress {\n    border-radius: 10px;\n    background-color: var(--templatesColorBackgroundContainer);\n    padding: 0.2em;\n    opacity: 0.3;\n    filter: grayscale(50%);\n}\n\n.ImageLoaderLoadingDisplay {\n    position: absolute;\n    left: 50%;\n    margin-left: -12em;\n    margin-top: 3em;\n    z-index: 22;\n}\n\n.ImageLoaderImageContainerContentCountWarning {\n    border-radius: 10px;\n    background-color: rgb(128, 88, 40);\n    padding: 0.2em;\n    animation: fadeInGlobal 1s;\n}\n\n.ImageCardImageContainer {\n    display: flex;\n    padding: 0.5em;\n    justify-content: center;\n    row-gap: 1em;\n    column-gap: 1em;\n    border-radius: 10px;\n}\n\n.ImageLoaderImageAndTitle {\n    /* border: 2px solid orange; */\n    min-width: 20em;\n    min-height: 10em;\n    text-align: center;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.ImageLoaderTextAndButton {\n    /* border: 2px solid red; */\n    min-width: 19em;\n    text-align: center;\n    flex-grow: 2;\n    display: flex;\n    row-gap: 1em;\n    column-gap: 1em;\n    justify-content: center;\n    padding: 1em;\n}\n\n.ImageLoaderLicenseText {\n    border: 2px solid var(--templatesColorBackgroundInContainer);\n    padding: 1em;\n    border-radius: 5px;\n    text-align: left;\n    overflow: auto;\n    min-width: 5em;\n    flex-grow: 2;\n    word-break: break-word;\n    font-size: 14px;\n}\n\n.ImageLoaderLicenseText::-webkit-scrollbar {\n    display: none;\n}\n\n.ImageLoaderInputValues {\n    border: 2px solid var(--templatesColorBackgroundInContainer);\n    padding: 1em;\n    border-radius: 5px;\n    flex-grow: 2;\n    word-break: break-word;\n    font-size: 14px;\n}\n\n.ImageLoaderImageBackButton {\n    margin-left: auto;\n}\n\n.ImageLoaderTitle {\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.ImageLoaderTitle p {\n    color: white;\n    font-weight: bold;\n}\n\n.ImageLoaderTitleAndBackButtonContainer {\n    display: flex;\n}\n\n.ImageLoaderLineBreak {\n    height: 3px;\n    background-color: var(--templatesColorBackgroundInContainer);\n    border: none;\n}\n\n@media screen and (max-width: 815px) {\n    .ImageLoaderInputValues {\n        font-size: 10px;\n    }\n\n    .ImageLoaderLicenseText {\n        font-size: 10px;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .ImageCardImageContainer {\n        display: block;\n    }\n\n    .ImageLoaderImageContainerContent {\n        width: 100%;\n    }\n\n    .ImageLoaderImageContainerContentRemoved {\n        width: 100%;\n    }\n\n    .ImageLoaderImageContainerContentLoadingProgress {\n        width: 100%;\n    }\n\n    .ImageLoaderImageContainerContentCountWarning {\n        width: 100%;\n    }\n\n    .ImageLoaderLoadingDisplay {\n        margin-left: -10em;\n        margin-top: 5em;\n    }\n\n    .ImageLoaderImageDisplay {\n        max-height: 9em;\n    }\n}\n\n@media screen and (max-width: 360px) {\n    .ImageLoaderTextAndButton {\n        padding: 0em;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .ImageLoaderImageDisplay {\n        max-height: 8em;\n        max-width: 15em;\n    }\n\n    .ImageLoaderInputValues {\n        padding: 0px;\n        padding-right: 1.9em;\n    }\n\n    .ImageLoaderTextAndButton {\n        row-gap: 0.1em;\n        column-gap: 0.1em;\n        min-width: 4em;\n        transform: scale(0.9);\n        flex-grow: 1;\n    }\n\n    .ImageLoaderImageAndTitle {\n        min-width: 10em;\n    }\n}\n\n@media screen and (max-width: 280px) {\n    .ImageLoaderImageAndTitle {\n        min-width: 1em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
